import {PortfolioSummary, PortfolioType} from "../../../../portfolio/models/Portfolio";

export class DashboardPortfolioSummaryModel {

    public constructor(public readonly portfolio: PortfolioSummary | null,
                       public readonly requiresDeposit: boolean,
                       public readonly isBroker: boolean,
                       public readonly totalCash: number,
                       public readonly todayCashChange: number,
                       public readonly nlv: number,
                       public readonly todayNlvChange: number,
                       public readonly buyingPower: number,
                       public readonly todayBuyingPowerChange: number,
                       public readonly marginLimit: number) {

    }

    public static build(portfolioSummary: PortfolioSummary | null): DashboardPortfolioSummaryModel {
        if (portfolioSummary == null) {
            return EMPTY;
        }
        const requiresDeposit = this.requiresDeposit(portfolioSummary);
        const isBroker = this.isRealPortfolio(portfolioSummary);
        const cashChange = this.todayCashChange(portfolioSummary);
        const nlvChange = this.todayNlvChange(portfolioSummary);
        const buyingPowerChange = this.todayBuyingPowerChange(portfolioSummary);
        const marginLimit = portfolioSummary.marginLimit || 0;
        return new DashboardPortfolioSummaryModel(portfolioSummary,
                                                  requiresDeposit,
                                                  isBroker,
                                                  portfolioSummary.totalCash,
                                                  cashChange,
                                                  portfolioSummary.nlv,
                                                  nlvChange,
                                                  portfolioSummary.excess,
                                                  buyingPowerChange,
                                                  marginLimit);
    }

    private static requiresDeposit(portfolioSummary: PortfolioSummary): boolean {
        return this.isRealPortfolio(portfolioSummary) && !this.hasCash(portfolioSummary);
    }

    private static isRealPortfolio(portfolioSummary: PortfolioSummary): boolean {
        return portfolioSummary.portfolioType === PortfolioType.BROKER;
    }

    private static hasCash(portfolioSummary: PortfolioSummary): boolean {
        return portfolioSummary.totalCash > 0;
    }

    private static todayCashChange(portfolioSummary: PortfolioSummary): number {
        const total = portfolioSummary.totalCash;
        const today = portfolioSummary.todayCashBalance;
        return total - today;
    }

    private static todayNlvChange(portfolioSummary: PortfolioSummary): number {
        const total = portfolioSummary.nlv;
        const today = portfolioSummary.todayNlv;
        return total - today;
    }

    private static todayBuyingPowerChange(portfolioSummary: PortfolioSummary): number {
        const total = portfolioSummary.excess;
        const today = portfolioSummary.todayShortageExcess;
        return total - today;
    }
}

const EMPTY: DashboardPortfolioSummaryModel = new DashboardPortfolioSummaryModel(null,
                                                                                 false,
                                                                                 false,
                                                                                 0,
                                                                                 0,
                                                                                 0,
                                                                                 0,
                                                                                 0,
                                                                                 0,
                                                                                 0);
